export default "__VITE_ASSET__DZ$YwFxw__"